export default {
  fillPriceList: "لیست قیمت را پر کنید",
  updatePriceList: "لیست قیمت را به روز کنید",
  "Studies available": "مطالعات در دسترس",
  "Studies limit about":
    "تعداد مطالعات قابل پردازش محدود است. برای افزایش محدودیت، با مدیر خود یا sales@3opinion.ai تماس بگیرید",
  "Studies limit reached":
    "حداکثر تعداد پردازش مطالعات انجام شده است. برای افزایش محدودیت، با مدیر خود یا sales@3opinion.ai تماس بگیرید",
  "Wait for upload": "لطفاً تا پایان آپلود فعلی صبر کنید",
  Upload: "بارگذاری",
  directory: "بارگذاری پوشه",
  zip: "بارگذاری فایل‌ها",
  gender: "جنسیت، سن",
  Name: "نام",
  Status: "وضعیت پردازش",
  studyDate: "تاریخ مطالعه",
  uploadDate: "تاریخ بارگذاری",
  "Dicom count": "تصاویر",
  Action: "عمل",
  Delete: "حذف",
  "Delete confirm": "آیا مطمئن هستید که می‌خواهید این مطالعه را حذف کنید؟",
  "Delete confirm about": "با حذف مطالعه، محدودیت پردازش تغییر نخواهد کرد",
  "No studies": "مطالعه‌ای وجود ندارد",
  Search: "جستجو",
  Cancel: "لغو",
  "Study status none": "شروع نشده",
  "Study status proccess": "در حال پردازش",
  "Study status not_found": "هیچ پاتولوژی یافت نشد",
  "Study status found": "پاتولوژی یافت شد",
  Wait: "در انتظار",
  "Zip processed": "در حال فشرده‌سازی",
  Done: "انجام شد",
  "Success upload":
    "فایل‌ها با موفقیت بارگذاری شدند. لیست مطالعات به‌روزرسانی خواهد شد",
  "Upload error": "سرور در دسترس نیست، لطفاً بعداً دوباره تلاش کنید",
  "Reach files size":
    "بارگذاری ممکن نیست. مجموع اندازه فایل‌ها از حد مجاز بیشتر است",
  "Upload process": "در حال پردازش",
  Yes: "بله",
  No: "خیر",
  "Study in queue": "در صف",
  "Study in proccess": "در حال پردازش",
  "Study not found": "پاتولوژی یافت نشد",
  "Study found": "پاتولوژی یافت شد",
  "Study error": "خطای پردازش",
  "Study error about": "خطای بارگذاری، لطفاً مطالعه را مجدداً بارگذاری کنید",
  patientID: "شناسه بیمار",
  male_short: "م",
  female_short: "ز",
  "Wait for anonimization": "در حال ناشناس‌سازی",
  "Wait for loading": "در حال بارگذاری",
  "Studies title": "لیست مطالعات | " + process.env.VUE_APP_INSTALL_NAME,
  "Error upload": "فرمت فایل‌های بارگذاری‌شده نامعتبر است",
  undefined__error: "فرمت فایل‌های بارگذاری‌شده نامعتبر است",
  good: "خوب",
  step0:
    "می‌توانید پوشه‌ای از مطالعات را بارگذاری کنید، سرویس آن‌ها را ناشناس‌سازی کرده و با هوش مصنوعی پردازش خواهد کرد",
  step1:
    "مطالعات شما در حال بارگذاری هستند، <br> این فرآیند چند دقیقه طول می‌کشد. <br><br> بارگذاری در پس‌زمینه انجام می‌شود، می‌توانید مطالعات دیگر را مشاهده کنید.",
  step2:
    "مطالعه پردازش‌شده توسط هوش مصنوعی در اینجا ظاهر خواهد شد. <br><br> پردازش ممکن است چند دقیقه زمان ببرد و در پس‌زمینه انجام می‌شود. در این زمان می‌توانید مطالعات دیگر را بررسی کنید.",
  "Demo Upload text": "پس از ثبت‌نام می‌توانید مطالعات خود را پردازش کنید",
  Register: "ثبت‌نام",
  "Demo Banner Text":
    "حساب کاربری ایجاد کنید و به سرویس‌های هوش مصنوعی و دوره‌های آموزشی دسترسی کامل پیدا کنید",
  Okay: "فهمیدم",
  "Mobile Notification":
    "در نسخه موبایل عملکرد محدود است.<br> برای دسترسی کامل سایت را در رایانه باز کنید.",
  "Studies limit Demo about":
    "پس از ثبت‌نام می‌توانید در حساب کاربری خود مطالعات را پردازش کنید",
  "Dicom count v2": "برش‌ها",
  prev: "قبلی",
  next: "بعدی",
  "Files select": "تعداد فایل‌های انتخاب‌شده",
  "Access files": "قابل پردازش توسط سرویس",
  "Access files about": "در حال بارگذاری روی سرور برای تحلیل هوش مصنوعی",
  "Skip files": "نامعتبر",
  "Tags values": "مقادیر برچسب‌ها",
  "Skip files about": "با الزامات سرویس مطابقت ندارند",
  Check: "بررسی",
  "Status short": "وضعیت",
  More: "بیشتر",
  TagError: {
    tail: "<br><br> مطالعه دیگری انتخاب کنید یا <a target='_blank' class='demo__underline demo__color--white' href='https://t.me/thirdopinion_support_bot'>به پشتیبانی پیام دهید</a>",
    not_exist: "برچسب <TAG> برای مطالعه مشخص نشده",
    some_error:
      "برچسب <TAG> با مقدار <TAG_VALUE> با الزامات سرویس <RULES> مطابقت ندارد",
    PatientsAge: "سن بیمار کمتر از ۱۸ سال است",
    Modality: "مدالیته",
    SliceThickness: "ضخامت برش",
    BodyPartExamined: "قسمت بدن مورد بررسی",
    StudyInstanceUID: "شناسه مطالعه",
    SeriesInstanceUID: "شناسه سری",
  },
};
